module.exports = __webpack_public_path__ + "static/media/42_B.7603f10a.png";